import React, { useState, useEffect } from "react";
import { $host } from "../../../../../http";
import "../UserModal.css"; // Общие стили

const generateRandomPassword = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
    let password = "";
    for (let i = 0; i < 8; i++) {
        password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
};

const ResetPasswordModal = ({ user, onClose }) => {
    const [newPassword, setNewPassword] = useState(generateRandomPassword());
    const [confirmPassword, setConfirmPassword] = useState(newPassword);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const generatedPassword = generateRandomPassword();
        setNewPassword(generatedPassword);
        setConfirmPassword(generatedPassword);
    }, []);

    const handleResetPassword = async () => {
        if (newPassword !== confirmPassword) {
            alert("Пароли не совпадают!");
            return;
        }

        setLoading(true);
        try {
            await $host.post("/api/admin/users/change-password", {
                user_email: user.email,
                new_password: newPassword,
            });

            alert("Пароль успешно изменён!");
            onClose();
        } catch (error) {
            console.error("Ошибка при смене пароля:", error);
            alert("Не удалось изменить пароль.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close" onClick={onClose}>✖</button>
                <h3 className="modal-header">Сброс пароля</h3>
                <p className="course-title"><strong>Пользователь:</strong> {user.email}</p>

                <div className="modal-section">
                    <label className="modal-label">Новый пароль:</label>
                    <input
                        type="text"  // Обычный текст, чтобы пароль не скрывался
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        className="modal-input"
                        placeholder="Введите новый пароль"
                        autoComplete="off"
                    />
                </div>

                <div className="modal-section">
                    <label className="modal-label">Подтвердите пароль:</label>
                    <input
                        type="text" // Обычный текст
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="modal-input"
                        placeholder="Повторите пароль"
                        autoComplete="off"
                    />
                </div>

                <div className="modal-footer">
                    <button className="modal-button modal-primary" onClick={handleResetPassword} disabled={loading}>
                        {loading ? "Сохранение..." : "Сбросить пароль"}
                    </button>
                    <button className="modal-button modal-danger" onClick={onClose}>Отмена</button>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordModal;
